export const getTextingPhoneNumber = (property: {
  phoneNumbers: { campaign: string, phoneNumber: string }[],
}): ?string => {
  return property?.phoneNumbers?.find((p) => p.campaign === 'Customer Care')
    ?.phoneNumber;
};
